import React, { useRef } from 'react';
import { useParams } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import LiveChat from '../components/LiveChat';
import QAChatbot from '../components/QAChatBot';
import "../App.css";
import BackToTopButton from '../components/BackToTopButton';
import ScrollSocialIcons from '../components/ScrollSocialIcons';

const jobOpenings = [
  { id: 1, title: "Sourcing & Inventory Controller", location: "Athurugiriya, Sri Lanka" },
  { id: 2, title: "Marine Engineer", location: "Athurugiriya, Sri Lanka" },
  { id: 3, title: "Operation Assistant", location: "Colombo, Sri Lanka" },
  { id: 4, title: "Senior Marine Welder", location: "Athurugiriya, Sri Lanka" },
  {id:6,title:"Assistant HR Manager", location: "Athurugiriya, Sri Lanka"},
  { id: 5, title: "Senior Technician", location: "Athurugiriya, Sri Lanka" },
  { id: 8, title: "Trainee / Junior Marketing Executive", location: "Colombo, Sri Lanka" },
  { id: 9, title: "Trainee / Junior Estimation & Invoicing Engineer", location: "Colombo, Sri Lanka" },
  { id: 10, title: "Trainee / Junior IT Engineer (Fresh Graduate)", location: "Colombo, Sri Lanka" },
  { id: 11, title: "Policy Making Intern", location: "Colombo, Sri Lanka" }
];

const Apply = () => {
  const { id } = useParams();
  const job = jobOpenings.find((job) => job.id === parseInt(id, 10));
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_v7xwleq',       // 🔁 Replace with your EmailJS Service ID
      'template_b9dzc2b',      // 🔁 Replace with your EmailJS Template ID
      formRef.current,
      'nY-PyzSMsXXjQl2Id'        // 🔁 Replace with your EmailJS Public Key
    ).then(
      (result) => {
        alert('Application sent successfully!');
        formRef.current.reset();
      },
      (error) => {
        alert('An error occurred. Please try again.');
        console.error(error.text);
      }
    );
  };

  if (!job) {
    return (
      <div>
        <Navbar />
        <div className="apply-hero">
          <div className="apply-hero-content">
            <h1>Job Not Found</h1>
          </div>
        </div>
        <LiveChat />
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Navbar />

      <div className="apply-hero">
        <div className="apply-hero-content">
          <h1>Apply for {job.title}</h1>
          <p>Location: {job.location}</p>
        </div>
      </div>

      <div className="application-form-section">
        <form ref={formRef} className="application-form" onSubmit={sendEmail}>
          <input type="hidden" name="jobTitle" value={job.title} />
          <input type="hidden" name="jobLocation" value={job.location} />

          <div className="form-group">
            <label>Full Name:</label>
            <input type="text" name="name" required />
          </div>

          <div className="form-group">
            <label>Email Address:</label>
            <input type="email" name="email" required />
          </div>

          <div className="form-group">
            <label>Phone Number:</label>
            <input type="text" name="phone" required />
          </div>

          <div className="form-group">
            <label>Resume (PDF/DOC):</label>
            <input type="file" name="resume" accept=".pdf,.doc,.docx" required />
          </div>

          <div className="form-group">
            <label>Cover Letter:</label>
            <textarea name="coverLetter" rows="5" />
          </div>

          <button type="submit" className="submit-btn">Submit Application</button>
        </form>
      </div>

      <LiveChat />
      <QAChatbot />
      <ScrollSocialIcons />
      <BackToTopButton />
      <Footer />
    </div>
  );
};

export default Apply;
